import { type CSSProperties } from "react";
import { type Quote } from "../types/quote";
import { QuoteSource } from "./QuoteSource";

interface QuoteListViewProps {
  quotes: Quote[];
}

export function QuoteListView({ quotes }: QuoteListViewProps) {
  return (
    <section style={styles.list}>
      {quotes.map((quote) => (
        <article key={quote.id} style={styles.row}>
          <p style={styles.content}>&ldquo;{quote.content}&rdquo;</p>

          <div style={styles.meta}>
            {quote.author ? <span style={styles.author}>{quote.author}</span> : null}
            <QuoteSource
              source={quote.source}
              style={styles.source}
              linkStyle={styles.sourceLink}
            />
          </div>
        </article>
      ))}
    </section>
  );
}

const styles = {
  list: {
    display: "flex",
    flexDirection: "column",
    gap: "10px",
  },
  row: {
    display: "grid",
    gridTemplateColumns: "minmax(0, 1fr) minmax(180px, 260px)",
    gap: "18px",
    alignItems: "start",
    padding: "18px",
    border: "1px solid var(--border)",
    borderRadius: "8px",
    background: "rgba(255, 255, 255, 0.035)",
  },
  content: {
    color: "var(--text-h)",
    fontSize: "18px",
    lineHeight: 1.45,
  },
  meta: {
    display: "flex",
    flexDirection: "column",
    gap: "4px",
    minWidth: 0,
  },
  author: {
    color: "var(--text-h)",
    fontSize: "14px",
    fontWeight: 700,
  },
  source: {
    color: "var(--text)",
    fontSize: "13px",
  },
  sourceLink: {
    color: "var(--accent)",
    fontSize: "13px",
    overflowWrap: "anywhere",
  },
} satisfies Record<string, CSSProperties>;
